import audio from '../../../../assets/audio/kids-tracks/Text11.mp3';

export const step12talk = {
    id: 12,
    title: 'Značka',
    taskText: `
        <p>
            Správně, je to zákaz zastavení. Tady nám žádné auto překážet nebude. Jestli chceš, můžeš se jít podívat do 
            výběhu k ovečkám, kousek od značky je vstup. Já s tebou nepůjdu, já se oveček bojím.
        </p>
    `,
    continueButtonText: 'Pokračovat v cestě',
    points: false,
    audio: audio,
};
